import { DataSource } from '@futrli-sdk/organisations';
import { ExcelUploadsListResponse } from '@futrli-sdk/predict';

/**
 * Returns the latest uploaded excel file data from the given input
 * @param filesRes - Excel uploads file list data
 */
export const getMostRecentExcelFile = (filesRes?: ExcelUploadsListResponse) => {
  return filesRes?.files.sort((a, b) => Number(new Date(b.created_at)) - Number(new Date(a.created_at)))[0];
};

/**
 * Returns the latest sync timestamp for the given datasource data
 * @param datasource - Datasource data
 * @param excelFiles - Excel files upload data, needed if datasource type is excel
 */
export const getLatestSyncTimestamp = (datasource?: DataSource, excelFiles?: ExcelUploadsListResponse) => {
  if (datasource?.type === 'excel') {
    const mostRecentFile = getMostRecentExcelFile(excelFiles);
    return mostRecentFile?.created_at || datasource.status.modified || '';
  } else {
    return datasource?.status.modified || '';
  }
};
